import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

/**
 * Profile picture with a calm initials fallback. Sizes: sm 28px · md 32px · lg 40px · xl 64px.
 */
export const UserAvatar = ({ user, size = "md", className, testId = "user-avatar" }) => {
  const dim = { sm: "h-7 w-7 text-[10.5px]", md: "h-8 w-8 text-[11px]", lg: "h-10 w-10 text-[13px]", xl: "h-16 w-16 text-[20px]" }[size] || "h-8 w-8 text-[11px]";
  return (
    <Avatar className={cn(dim, "ring-1 ring-border", className)} data-testid={testId}>
      {user?.avatar_url ? <AvatarImage src={user.avatar_url} alt="" className="object-cover" /> : null}
      <AvatarFallback className="bg-primary/10 font-semibold text-primary" delayMs={user?.avatar_url ? 300 : 0}>
        {initials(user?.name)}
      </AvatarFallback>
    </Avatar>
  );
};
